<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form novalidate class="app-pay-form" @submit.prevent="withdrawal">
          <div class="col" v-for="(item,key) in _.orderBy(providerInfo.form, ['sort'], ['asc'])" :key="key" >
            <div class="inline-form">
              
              <label>{{ $t('payment.form.' + item.title) }}</label>
              
              <input v-model="form[item.title]" v-if="item.type == 'input'" :required="_.some(_.map(['required'], w => item.rules.includes(w)), Boolean)" :type="item.input_type" :placeholder="$t('payment.form.' + item.description)">
    
              <select v-model="form[item.title]" v-if="item.type == 'select'" :required="_.some(_.map(['required'], w => item.rules.includes(w)), Boolean)">
                  <option :value="null" disabled>Seçiniz</option>
                  <option v-for="(value,key) in item.values" :key="key" :value="value.id">{{ value.title }}</option>
              </select>

            </div>
          </div>

					<div class="col" v-if="check_checkbox">
						<div class="inline-form">
							<label>Kabul ediyorum</label>
							<input type="checkbox" checked='checked' v-model="form.accept_rule"/>
						</div>
					</div>

          <div class="col">
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Çek'" />
          </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props: ['providerInfo'],
    data(){
      return{
        form: {
          service: this.$route.params.payment,
          setting_id: null,
        },
        loading: false,
        btnLoading: false,
        check_checkbox: false,
      }
    },
    created(){
      this.form.setting_id = this.providerInfo.setting_id;
      this.providerInfo.form.forEach((item, index) => {
        this.form[item.title] = null;
      });
    },
    methods:{
      withdrawal(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/withdrawal/generate/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          }
        })
        .catch((err) => {
          if (err.response.data.check_checkbox){
            this.check_checkbox = true;
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
    },
    components:{
      Header,
      Form
    }
  }

</script>
